module.exports = __webpack_public_path__ + "static/media/language_EN.e71ca62f.svg";